<template>
  <div>
    <!-- <MyHeader></MyHeader> -->
    <div
      v-if="isShowOrdered"
      class="wrap"
    >
      <div class="wrap-top">
        <div class="tab-box">
          <div
            :class="['tab-item',{select:'all'===orderSource.select}]"
            @click="orderSource.on.click('all')"
          >
            <span class="tab-item-text">所有</span>
          </div>
          <div
            v-for="(item,index) in orderSource.list"
            :key="index"
            :class="['tab-item',{select:index===orderSource.select}]"
            @click="orderSource.on.click(index)"
          >
            <span class="tab-item-text">{{ item.value }}</span>
          </div>
        </div>
        <button
          class="create-app"
          @click="goCreateApp"
        >
          订购产品
        </button>
      </div>
      <!-- <div
      v-if="'all'===orderSource.select"
      class="tab1-box"
    >
      <div

        :class="['tab1-item',{select:'all'===appOrderType.select}]"
        @click="appOrderType.on.click('all')"
      >
        <span class="tab1-item-text">所有</span>
      </div>
      <div
        v-for="(item,index) in appOrderType.list"
        :key="index"
        :class="['tab1-item',{select:index===appOrderType.select}]"
        @click="appOrderType.on.click(index)"
      >
        <span class="tab1-item-text">{{ item.label }}</span>
      </div>
    </div> -->

      <!-- <div class="app-box">
        <div
          v-for="(item,index) in app.list"
          :key="index"
          class="app-item"
        >
          <div class="app-name">
            渭南全域旅游
          </div>
          <div class="app-intro">
            景区门票综合解决方案，助力精准直销
          </div>
          <div>
            <button
              class="buy-btn"
              @click="order"
            >
              我要订购
            </button>
          </div>
          <img
            class="app-logo"
            src="@/assets/images/demo/logo.png"
          >
        </div>
      </div> -->
      <div
        v-if="appOrderedList.length"
        class="app1-box"
      >
        <div
          v-for="(item,index) in appOrderedList"
          :key="index"
          class="app1-item"
        >
          <div class="app1-content">
            <div class="app1-name">
              <span class="app1-name-text">
                <span>{{ item|filterAppName }}...</span>
              </span>
              <!-- needOpen 1:需要开通，0:否，2：已开通 -->
              <!-- currentStatus 1:正常状态，2：即将到期，3：已过期 -->
              <span
                v-if="item.currentStatus===2"
                class="status status0"
              >
                <!-- <span>即将到期</span> -->
                <span v-if="item.surplusDays">剩余{{ item.surplusDays }}天</span>
                <span v-else>今日到期</span>
              </span>
              <span
                v-else-if="item.currentStatus===3"
                class="status status1"
              >
                已到期
              </span>
              <span
                v-else-if="item.currentStatus===1 && item.needOpen===1"
                class="status status2"
              >
                待开通
              </span>
              <!-- <span
                v-else-if="item.currentStatus===1 && item.needOpen===2"
                class="status status2"
              >
                已开通
              </span> -->
            </div>
            <!-- <div class="app1-intro">
              系统账号：{{ item.accountNo }}
            </div> -->
            <div class="app1-intro">
              到期时间：{{ item.serviceEnd }}
            </div>
            <div class="app1-intro">
              主体信息：
              <span class="app1-corp-intro">{{ item.corpName }}</span>({{ item.accountNo }})
            </div>
            <div
              class="app1-intro"
              style="height: 18px"
            >
              <template v-if="item.parentAccountName">
                所属应用：
                <span class="app1-corp-intro">{{ item.parentAccountName }}</span>
              </template>
            </div>
          </div>
          <div class="app1-footer">
            <button
              v-if="item.subEntranceFlag!==1"
              class="btn"
              @click="goAppOrderDetail(item)"
            >
              订购详情
            </button>
            <button
              class="btn"
              @click="goShop(item)"
            >
              进入店铺
            </button>
            <button
              v-if="([2,3].includes(item.currentStatus) && [0,2].includes(item.needOpen))||
                item.needOpen==1 && item.currentStatus==3
              "
              class="btn1"
              @click="goAppOrderDetail(item)"
            >
              续费
            </button>
            <!-- <button
            v-else-if="item.status===1"
            class="btn1"
          >
            续费
          </button> -->
            <!-- <button
              v-else-if="item.needOpen===1 && [1,2].includes(item.currentStatus)"
              class="btn1"
              @click="goShop(item)"
            >
              开通
            </button> -->
          </div>
          <img
            class="app1-logo"
            :src="item.productSmallIcon||'@/assets/images/demo/logo.png'"
          >
        </div>
      </div>
      <div
        v-else-if="!appOrderedList.length"
        style="text-align: center; color: #999;"
      >
        <img src="@/assets/images/empty.png">
        <div>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
// import MyHeader from '@/components/Layout/Header';
export default {
  name: 'Index',
  components: {
    // MyHeader,
  },
  filters: {
    filterAppName(item={}){
      const appName = item.accountName || item.productName;
      if (appName && appName.length>7){
        return `${appName.substr(0,7)}...`;
      }
      return appName;
    },
  },
  data(){
    return {
      isShowOrdered: false,
      // contentheight: '',
      orderSource: {
        select: 'all',
        list: [],
        on: {
          click: (index)=>{
            this.orderSource.select = index;
            // 默认主体选择第一个
            // const item = this.orderSource.list[index]||{};
            // this.$store.commit('setUserInfo',{
            //   orderSource: item.key,
            // });
            this.getOrderedList();
          },
        },
      },
      // appOrderType: {
      //   select: 'all',
      //   list: [
      //     {
      //       label: '未订购',
      //     },
      //     {
      //       label: '已订购',
      //     },
      //   ],
      //   on: {
      //     click: (index)=>{
      //       this.appOrderType.select = index;
      //     },
      //   },
      // },
      // app: {
      //   list: [
      //   ],
      // },
      appOrderedList: [],
    };
  },
  created(){
    // 如果已经登陆了
    const {token} = this.$store.state.user.userInfo;
    if (token){
      this.isShowOrdered = true;
      // if (corpList && corpList.length){
      //   // 认证时

      // }
      // 获取系统列表
      this.getSource();
      // 获取已订购的产品
      this.getOrderedList();
    } else {
      this.isShowOrdered = false;
      // // 查询商品列表
      // this.getListAllProductOnline();
      this.goCreateApp();
    }

  },
  mounted() {
    // this.contentheight = `${window.innerHeight - 80 }px`;
    // 头部主体变化事件绑定
    // 防止多次监听
    // this.$root.$off('on-corp-change');
    this.$root.$on('on-corp-change', () => {
      // 重新获取已订购的产品
      this.getOrderedList();
    });
  },
  beforeDestroy(){
    // 防止多次监听
    this.$root.$off('on-corp-change');
  },
  methods: {
    // 获取系统列表
    getSource(){
      const url = '/paycenter-charge/api/worktable/order/source';
      const {corpCode} = this.$store.state.user.userInfo;
      if (!corpCode){
        return;
      }
      this.$http.get(url,{corpCode}).then(res=>{
        if (res.success){
          this.orderSource.list = res.data;
        } else {
          this.$Message.warning(res.message||'获取数据失败');
        }
      });
    },
    // 获取已订购的产品
    getOrderedList(){
      const {corpCode} = this.$store.state.user.userInfo;
      this.appOrderedList = [];
      if (!corpCode){
        return;
      }
      const item = this.orderSource.list[this.orderSource.select]||{};
      const url = '/paycenter-charge/api/worktable/ordered/list';
      const params = {corpCode,orderSource: item.key};
      this.$http.get(url,params).then(res=>{
        if (res.success){
          this.appOrderedList = res.data;
        } else {
          this.$Message.warning(res.message||'获取数据失败');
        }
      });

    },
    goAppOrderDetail(item){
      const {productCode,buyerId} = item;
      const {href} = this.$router.resolve({
        path: '/app/order/Detail',
        query: {
          productCode,buyerId,
        },
      });
      // window.open(href,'_blank');
      window.location.href = href;
    },
    order(){
      this.$router.push({
        path: '/standardProduct/productVersion/index',
        query: {
          productCode: '43a92153-873b-40cc-b935-b7bf8fe4bd82',
        },
      });
    },
    goCreateApp(){
      // this.isShowOrdered = false;
      // this.getListAllProductOnline();
      // // this.$emit('hide-ordered');
      this.$router.push({
        path: '/app/market/list',
        // query: {

        // },
      });
    },
    // 进入店铺
    goShop(item){
      const {productCode,buyerId,serviceUrl,entranceFlag} = item;
      const url = '/paycenter-charge/api/worktable/goShop';
      const params = {productCode,buyerId,serviceUrl,entranceFlag};
      this.$http.get(url,params).then(res=>{
        if (res.success){
          if (res.data){
            // window.open(res.data,'_blank');
            window.location.href = res.data;
          } else {
            this.$Message.warning('未配置服务入口');
          }
        } else {
          this.$Message.warning(res.message||'获取数据失败');
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrap {
  width: 1200px;
  margin: 0 auto;
  // margin-top: 20px;
}
.wrap-top {
  border-bottom: 1px solid #ebebeb;
  position: relative;
  margin-bottom: 10px;
  .create-app {
    position: absolute;
    right: 20px;
    top: 0;
    border: 0;
    background-color: #5a81ff;
    color: #fff;
    border-radius: 20px;
    padding: 5px 10px;
    cursor: pointer;
  }
}
.tab-box {
  display: flex;
  box-sizing: border-box;
  padding: 0 40px;
  .tab-item {
    margin-right: 30px;
    margin-bottom: -1px;
    cursor: pointer;
    .tab-item-text {
      display: inline-block;
      padding: 10px 5px;
    }
    &.select {
      .tab-item-text {
        border-bottom: 3px solid #4772fc;
      }
    }
  }
}
.app1-box {
  display: flex;
  // justify-content: center;
  flex-wrap: wrap;
  width: 1230px;
  margin-left: -15px;
  .app1-item {
    width: 283px;
    flex-shrink: 0;
    margin: 12px;
    box-shadow: 0 0 15px 1px #ddd;
    box-sizing: border-box;
    border-radius: 5px;
    position: relative;
    transition: all ease 300ms;
    .app1-footer {
      border-radius: 0 0 5px 5px;
      padding: 10px 25px;
      .btn {
        border: 0;
        background-color: transparent;
        color: #666;
        margin-right: 20px;
        cursor: pointer;
        font-size: 12px;
      }
      .btn1 {
        cursor: pointer;
        float: right;
        padding: 2px 15px;
        color: #fff;
        background-color: #5a81ff;
        border: 0;
        border-radius: 4px;
        font-size: 12px;
      }
    }
    &:hover {
      box-shadow: 0 0 15px 1px #ddd;
      // box-shadow: 0 10px 20px 0 rgb(0 0 0 / 10%);
      transform: translateY(-5px);
      .app1-footer {
        background-image: linear-gradient(to right, #e4f6ff, #e2e9ff);
        .btn {
          color: #5a81ff;
        }
      }
    }
    .app1-content {
      padding: 20px 25px 10px;
    }
    .app1-name {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
      .app1-name-text {
        display: inline-block;
        vertical-align: middle;
        max-width: 140px;
        overflow: hidden;
        // text-overflow: ellipsis;
        white-space: nowrap;
      }
      .status {
        border-radius: 20px;
        display: inline-block;
        vertical-align: middle;
        padding: 2px 6px;
        font-size: 12px;
        margin-left: 6px;
        font-weight: normal;
        color: #fff;
        &0 {
          // border: 1px solid #fb5741;
          // background-color: #fb5741;
          background-image: linear-gradient(to right, #ff763a, #fb5741);
        }
        &1 {
          // border: 1px solid #666;
          background-color: #666;
        }
        &2 {
          // border: 1px solid #ff763a;
          background-color: #ff763a;
        }
      }
    }
    .app1-intro {
      font-size: 12px;
      font-weight: 500;
      color: #999;
      margin-bottom: 5px;
    }
    .app1-corp-intro {
      display: inline-block;
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
    .app1-logo {
      position: absolute;
      width: 34px;
      height: 34px;
      right: 10px;
      top: 10px;
      border-radius: 100%;
    }
  }
}
.app-type-box {
  margin-bottom: 10px;
}
.app-type {
  font-size: 18px;
  color: #1b1c26;
  margin-bottom: 10px;
  // font-weight: 700;
}
.app-box {
  display: flex;
  // justify-content: center;
  flex-wrap: wrap;
  width: 1230px;
  margin-left: -15px;
  .app-item {
    box-sizing: border-box;
    width: 283px;
    // flex-shrink: 0;
    margin: 12px;
    box-shadow: 0 0 15px 1px #ddd;
    padding: 20px 25px 25px;
    border-radius: 5px;
    position: relative;
    transition: all ease 300ms;
    background-size: 100% 100%;
    // background-image: url();
    &:nth-child(3n+1) {
      background-color: #1a89ff;
    }
    &:nth-child(3n+2) {
      background-color: #8654ff;
    }
    &:nth-child(3n) {
      background-color: #4e74f0;
    }
    &:hover {
      box-shadow: 0 0 15px 1px #ddd;
      // box-shadow: 0 10px 20px 0 rgb(0 0 0 / 10%);
      transform: translateY(-5px);
    }
    .app-name {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .app-intro {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
      margin-bottom: 20px;
      width: 85%;
      overflow: hidden;
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .buy-btn {
      color: #fff;
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.2);
      padding: 6px 12px;
      line-height: 1;
      border: 0;
      font-size: 14px;
    }
    .app-logo {
      display: block;
      // border: 0;
      position: absolute;
      width: 34px;
      height: 34px;
      right: 25px;
      top: 19px;
      border-radius: 100%;
    }
  }
}
</style>
